<template>
	<div class="class_select_list">
		<div id="class_name_content" :class="(item.class_id == current_class && show_detail) ? 'class_name_content' : 'class_name_content_select'" v-for="item in all_date" :key="item.class_id">
			<div id="class_name" @click="class_click(item)">{{item.class_name}}  {{item.class_des}}
				<img :src='(item.class_id == current_class && show_detail) ? "https://resources.xycoder.com/dowa/images/arrow_down.png" : "https://resources.xycoder.com/dowa/images/arrow_up.png" ' alt="">
			</div>
			<ul id="current_class_content" v-show="item.class_id == current_class && show_detail">
				<li id="current_class_name" v-for="list in item.products" :key="list.product_id" @click="product_click(list)">{{clipTitle(list.product_name)}}</li>
			</ul>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Vue from "vue";
	import store from '@/store/index.js';

	export default{
        name:"classSelectList",
        props: {
            show_detail: {
                type: Boolean,
                default: true
            }
        },
		data(){
			return{
				current_class: null,
				current_class_date: null,
				all_date:null
			}
		},

		computed:{
			allProductDate(){
				return store.state.product_data;
			}
		},
		mounted() {
			this.current_class = this.$route.params.class;
			var product_id = this.$route.params.id;
			if (!this.current_class && product_id) {
				var alldate = this.all_date
				if (!alldate) {
					return
				}
				alldate.forEach(product_class => {
					var products = product_class.products
					products.forEach(product => {
						console.log(product)
						if (product.product_id == product_id) {
							this.current_class = product.product_class_id
						}
					});
				});
			}
			// console.log('路由传参：' + this.current_class);
			// console.log(product_id);
			// store.state.product_data = store.state.product_data;
		},
		methods:{
			class_click(item){
				// console.log(item.class_name);
                this.$router.push({name:'productClass',params:{class:item.class_id}});
                this.$emit('classClickBlock', item);
                
			},
			clipTitle(title){
                return title.split("（")[0]
            },
			product_click(list){
                // console.log(list.product_name);
                this.$router.push({name:'productinfo',params:{id:list.product_id}});
                this.$emit('productClickBlock', list);
			}
		},
		watch:{
			$route(){
				this.current_class = this.$route.params.class;
			},
			allProductDate:{
				immediate:true,
				deep:true,
				handler:function(newValue,oldValue){
					// console.log('开始监听');
					//  console.log(newValue);
					//  console.log(oldValue);
					if (newValue == null || newValue.classes == null) {
						return
					}
					 this.all_date = newValue.classes;
				 }
			}
		}
	}

</script>

<style type="text/css" scoped>
	.product_class{
		margin-top: 50px;
    }
    .class_select_list{
		background-color:white;
		margin: 10px;
		border-radius: 10px;
		box-shadow: 0px 0px 20px rgb(230,230,230);
    }
    .class_name_content{
		/* border-top:1px solid gray; */
		background: white;
	}
	.class_name_content_select{
		/* border-top:1px solid gray; */
    }
    #class_name{
        color: rgb(19, 136, 142);
        line-height: 40px;
        /* height: 100%; */
		padding-left: 20px;
    }

	#class_name img{
		float: right;
		padding-top: 14px;
		padding-right: 15px;
		width: 15px;
		height: 9px;
	}
    #current_class_name{
        color: rgb(19, 136, 142);
        line-height: 30px;
		/* padding-left: 30px; */
		margin-left: 30px;
		border-top: 1px solid lightgray;

		background: white;
    }
	ul{
		padding:0px; 
	}
	li{
		list-style-type: none;
	}

	/* canvas {
		display: block;
		position: absolute;
		bottom: 100px;
		right: -24px;
		z-index: 20;
		cursor: pointer;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	} */
</style>


// WEBPACK FOOTER //
// src/components/ClassSelectList.vue